export enum SurveyTab {
  Questions = 'Questions',
  Quotas = 'Quotas',
  Logic = 'Logic',
  Tagging = 'Tag Builder',
}

export default SurveyTab;